var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmazonGbIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.740234,
    y: 0.954224,
    width: 21,
    height: 15,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5728_64466",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.740234,
    y: 0.954224,
    width: 21,
    height: 15,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5728_64466)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.740234,
    y: 0.954224,
    width: 21,
    height: 15,
    fill: "#0A17A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.221458 -0.483109L8.74039 5.56174V-0.0457739H13.7404V5.56174L22.7022 -0.483109L23.8206 1.17497L16.7351 5.95423H21.7404V10.9542H16.7351L23.8206 15.7335L22.7022 17.3916L13.7404 11.3467V16.9542H8.74039V11.3467L-0.221458 17.3916L-1.33984 15.7335L5.7457 10.9542H0.740394V5.95423H5.7457L-1.33984 1.17497L-0.221458 -0.483109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7422 5.70337L24.2412 -0.545776",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 11.2274L24.2654 16.967",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74359 5.68707L-2.13867 -0.299011",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70697 11.1579L-2.13867 17.6871",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.740234 9.95422H9.74024V15.9542H12.7402V9.95422H21.7402V6.95422H12.7402V0.954224H9.74024V6.95422H0.740234V9.95422Z",
    fill: "#E6273E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonGbIcon);
export default __webpack_public_path__ + "static/media/amazon-gb-icon.39ff7ece9d655715555679b258a7b870.svg";
export { ForwardRef as ReactComponent };